import React from 'react';

import SoftyCandado from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftyCandado/List.js';

export default function () {
  return <SoftyCandado />;
}
